/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IGetNewObjectInfoResponseSchema } from '../../entities/schemas/GetNewObjectInfoResponseSchema';

export type TGetNewobjectInfoModel = IModel<IGetNewobjectInfoRequest, TGetNewobjectInfoResponse>;

export interface IGetNewobjectInfoRequest {
  /** Идентификатор ЖК **/
  newobjectId?: number | null;
  /** идентификатор застройщика **/
  builderId?: number | null;
}

export type TGetNewobjectInfoResponse =
  | IGetNewobjectInfoResponse200
  | IGetNewobjectInfoResponse400
  | IGetNewobjectInfoResponse404;

export interface IGetNewobjectInfoResponse200 extends IModelResponse<IGetNewobjectInfoResponse> {
  statusCode: 200;
}

export interface IGetNewobjectInfoResponse400 extends IModelResponse<IGetNewobjectInfoResponseError> {
  statusCode: 400;
}

export interface IGetNewobjectInfoResponse404 extends IModelResponse<IGetNewobjectInfoResponseNotFoundError> {
  statusCode: 404;
}

export interface IGetNewobjectInfoResponse {
  data: IGetNewObjectInfoResponseSchema;
  status: EStatus;
}

export interface IGetNewobjectInfoResponseError {
  errors: any[];
  message: string;
}

export interface IGetNewobjectInfoResponseNotFoundError {
  errors: any[];
  message: string;
}

export type TResponses =
  | IGetNewobjectInfoResponse
  | IGetNewobjectInfoResponseError
  | IGetNewobjectInfoResponseNotFoundError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400, TResponse404> {
  200(response: IGetNewobjectInfoResponse): TResponse200;
  400(response: IGetNewobjectInfoResponseError): TResponse400;
  404(response: IGetNewobjectInfoResponseNotFoundError): TResponse404;
}
